'use client'

import React from 'react'

import { HTMLChakraProps } from '@chakra-ui/react'

import { ColorScheme } from '../../types'
import { TAG_HEIGHT } from '../Tag/Tag.styles'
import { Button } from './Button'

export type IconButtonProps = HTMLChakraProps<'button'> & {
  'aria-label': string
  icon: React.ReactNode
  colorScheme?: ColorScheme
  bgColor?: string
  hoverBgColor?: string
  textColor?: string
  dimension?: number
}

export const IconButton = ({
  'aria-label': ariaLabel,
  icon,
  colorScheme,
  onClick,
  bgColor,
  hoverBgColor,
  textColor,
  dimension = TAG_HEIGHT,
  disabled,
  ...rest
}: IconButtonProps) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''
  const extraStyles = {
    bg: bgColor ?? 'transparent',
    borderWidth: '0px',
    borderColor: 'transparent',
    _hover: { bg: hoverBgColor ?? `${prefix}interactive.icon-button-hover-bg` },
    _active: { bg: `${prefix}interactive.icon-button-pressed-bg` },
    ...(textColor && { color: textColor }),
  }

  const iconWithColorScheme =
    colorScheme != null && React.isValidElement(icon)
      ? React.cloneElement(
          icon as React.ReactElement<{ colorScheme?: ColorScheme }>,
          {
            colorScheme,
          }
        )
      : icon

  return (
    <Button
      aria-label={ariaLabel}
      borderRadius='0px'
      colorScheme={colorScheme}
      disabled={disabled}
      onClick={onClick}
      px='0'
      size='sm'
      style={{
        height: `${dimension}px`,
        width: `${dimension}px`,
        minWidth: `${dimension}px`,
      }}
      {...(extraStyles as any)}
      {...rest}
      variant='tertiary'
    >
      {iconWithColorScheme}
    </Button>
  )
}
